import { Box } from '@chronosphereio/chrono-ui';
import { Tab, Tabs, TabsProps } from '@mui/material';
import { useState } from 'react';
import { OptionsEditorTabPanel } from '../OptionsEditorTabPanel';

export type OptionsEditorTab = {
  label: string;
  /**
   * Content rendered when the tab is active.
   */
  content: React.ReactNode;
};

export type OptionsEditorTabsProps = {
  tabs: OptionsEditorTab[];
};

export const OptionsEditorTabs = ({ tabs }: OptionsEditorTabsProps) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange: TabsProps['onChange'] = (_, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: (theme) => theme.palette.divider }}>
        <Tabs value={activeTab} onChange={handleChange} aria-label="Panel configuration tabs">
          {tabs.map(({ label }, i) => {
            return (
              <Tab
                key={label}
                label={label}
                id={`options-editor-tab-${i}`}
                aria-controls={`options-editor-tabpanel-${i}`}
              />
            );
          })}
        </Tabs>
      </Box>
      {tabs.map(({ label, content }, i) => {
        return (
          <OptionsEditorTabPanel key={label} value={activeTab} index={i}>
            {content}
          </OptionsEditorTabPanel>
        );
      })}
    </>
  );
};
